import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/AuthContext';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import Loading from '../Shared/Loading';
import ErrorAlert from '../Shared/ErrorAlert';
import MakePaymentDialog from './Dialogs/MakePaymentDialog';
import BuyerTemplate from '../RoleTemplate/BuyerTemplate.jsx';

const validPaymentStatuses = ['Awaiting Payment', 'Reserved', 'Pending'];

const BuyerMakePayment = () => {
  const { t } = useTranslation();
  const { getUserUUID } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [assessments, setAssessments] = useState([]);
  const [buyerId, setBuyerId] = useState(null);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);

  useEffect(() => {
    let unsubscribe;

    const initializePaymentPage = async () => {
      try {
        const userId = await getUserUUID();
        setBuyerId(userId);

        const assessmentsRef = collection(db, 'assessment_requests');
        const q = query(
          assessmentsRef,
          where('buyer_id', '==', userId),
          where('paymentStatus', 'in', validPaymentStatuses)
        );

        unsubscribe = onSnapshot(
          q,
          (querySnapshot) => {
            const fetchedAssessments = querySnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            setAssessments(fetchedAssessments);
            setPaymentDialogOpen(fetchedAssessments.length > 0);
            setLoading(false);
          },
          (err) => {
            console.error('Error fetching assessments:', err);
            setError(t('api_error'));
            setLoading(false);
          }
        );
      } catch (err) {
        console.error('Error initializing payment page:', err);
        setError(t('api_error'));
        setLoading(false);
      }
    };

    initializePaymentPage();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [t, getUserUUID]);

  const handleClosePaymentDialog = () => {
    setPaymentDialogOpen(false);
  };

  return (
    <BuyerTemplate title={t('makeAPayment')}>
      {loading ? (
        <Loading />
      ) : error ? (
        <ErrorAlert error={error} />
      ) : (
        <Box sx={{ mt: 2 }}>
          {assessments.length > 0 ? (
            <MakePaymentDialog
              open={paymentDialogOpen}
              onClose={handleClosePaymentDialog}
              buyerId={buyerId}
              assessments={assessments}
            />
          ) : (
            <p>{t('noPendingPayments')}</p>
          )}
        </Box>
      )}
    </BuyerTemplate>
  );
};

export default BuyerMakePayment;
